import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, Users, Ruler, UserCheck } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { yachts } from '../data/mock';

const YachtDetailPage = () => {
  const { id } = useParams();
  const yacht = yachts.find((y) => y.id === id);

  if (!yacht) {
    return (
      <div className="min-h-screen bg-gray-950 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-white mb-4">Yacht not found</h1>
          <Link to="/yachts" className="text-orange-500 hover:underline">
            Back to Fleet
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-950">
      <Navbar />
      
      {/* Hero Image */}
      <section className="relative h-[60vh] pt-20">
        <img
          src={yacht.image}
          alt={yacht.name}
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-gray-950 via-gray-950/50 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-8">
          <div className="max-w-7xl mx-auto">
            <Link
              to="/yachts"
              className="inline-flex items-center gap-2 text-white/70 hover:text-white mb-4 transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              Back to Fleet
            </Link>
            <span className="block text-orange-500 text-sm font-medium mb-2">{yacht.type}</span>
            <h1 className="text-4xl md:text-5xl font-serif font-bold text-white">{yacht.name}</h1>
          </div>
        </div>
      </section>

      {/* Details */}
      <section className="py-16 bg-gray-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Main Content */}
            <div className="lg:col-span-2">
              <h2 className="text-2xl font-serif font-bold text-white mb-4">About {yacht.name}</h2>
              <p className="text-white/70 leading-relaxed mb-8">{yacht.description}</p>
              
              {/* Specs */}
              <div className="grid grid-cols-3 gap-4 mb-8">
                <div className="p-6 bg-gray-900 rounded-xl border border-gray-800">
                  <Ruler className="w-6 h-6 text-orange-500 mb-3" />
                  <p className="text-white/50 text-sm">Length</p>
                  <p className="text-white font-semibold">{yacht.length}</p>
                </div>
                <div className="p-6 bg-gray-900 rounded-xl border border-gray-800">
                  <Users className="w-6 h-6 text-orange-500 mb-3" />
                  <p className="text-white/50 text-sm">Guests</p>
                  <p className="text-white font-semibold">{yacht.guests}</p>
                </div>
                <div className="p-6 bg-gray-900 rounded-xl border border-gray-800">
                  <UserCheck className="w-6 h-6 text-orange-500 mb-3" />
                  <p className="text-white/50 text-sm">Crew</p>
                  <p className="text-white font-semibold">{yacht.crew}</p>
                </div>
              </div>
            </div>

            {/* Booking Card */}
            <div className="lg:col-span-1">
              <div className="sticky top-24 p-6 bg-gray-900 rounded-2xl border border-gray-800">
                <div className="mb-6">
                  <span className="text-white/50 text-sm">Starting from</span>
                  <p className="text-3xl font-bold text-orange-500">
                    ${yacht.price.toLocaleString()}<span className="text-sm font-normal text-white/50">/day</span>
                  </p>
                </div>
                <Link
                  to="/booking"
                  className="block w-full py-4 bg-orange-500 text-white text-center font-medium rounded-lg hover:bg-orange-600 transition-colors"
                >
                  Book This Yacht
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default YachtDetailPage;
